/* The decoration around the button (that animate when hovered) */

.primary_button {
  position: relative;
}

/* Top-left and bottom-right corners */
.top_left_bottom_right::before,
.top_left_bottom_right::after {
  content: '';
  position: absolute;
  width: 9px;
  height: 9px;
  transition-duration: 800ms;
  transition-timing-function: cubic-bezier(0.16, 1, 0.3, 1); /* ease-out-expo */
  transition-property: width, height;
}

.top_left_bottom_right::before {
  top: -5px;
  left: -5px;
  border-top: 1px solid var(--border-color);
  border-left: 1px solid var(--border-color);
}

.top_left_bottom_right::after {
  right: -5px;
  bottom: -5px;
  border-bottom: 1px solid var(--border-color);
  border-right: 1px solid var(--border-color);
}

/* Top-right and bottom-left corners */
.top_right_bottom_left::before,
.top_right_bottom_left::after {
  content: '';
  position: absolute;
  width: 9px;
  height: 9px;
  transition: 0.3s ease-in-out;
}

.top_right_bottom_left::before {
  top: -5px;
  right: -5px;
  border-top: 1px solid var(--border-color);
  border-right: 1px solid var(--border-color);
}

.top_right_bottom_left::after {
  left: -5px;
  bottom: -5px;
  border-bottom: 1px solid var(--border-color);
  border-left: 1px solid var(--border-color);
}

/* Hover effect - corners expand to full borders */
.primary_button:hover .top_left_bottom_right::after,
.primary_button:hover .top_left_bottom_right::before {
  width: calc(100% + 9px);
}

.primary_button:hover .top_right_bottom_left::after,
.primary_button:hover .top_right_bottom_left::before {
  height: calc(100% + 9px);
}
